import Footer from "../../components/Footer";
import { Header } from "../../components/Header";
import "./FinancialStatements.scss";

const documents = [
  {
    year: 2024,
    publishedAt: "13/03/2025",
    pdfUrl:
      "/assets/documents/financial-statements/2024-demonstracoes-financeiras.pdf",
  },
  {
    year: 2023,
    publishedAt: "15/10/2024",
    pdfUrl:
      "/assets/documents/financial-statements/2023-demonstracoes-financeiras.pdf",
  },
  {
    year: 2022,
    publishedAt: "16/10/2023",
    pdfUrl:
      "/assets/documents/financial-statements/2022-demonstracoes-financeiras.pdf",
  },
  {
    year: 2021,
    publishedAt: "06/10/2022",
    pdfUrl:
      "/assets/documents/financial-statements/2021-demonstracoes-financeiras.pdf",
  },
];

const documentTitle =
  "Demonstrações Financeiras e Opinião do Auditor";

const FinancialStatements = () => {
  return (
    <div className="financial-statements-page">
      <Header reduced={true} />

      <main className="financial-statements-main">
        <section className="financial-statements-shell">
          <div className="financial-copy">
            <span className="section-label">TRANSPARÊNCIA INSTITUCIONAL</span>
            <h1>KRL Services - Demonstrações Financeiras</h1>
            <p>
              Acesse os documentos contábeis oficiais da KRL organizados por
              exercício.
            </p>
          </div>

          <ul className="financial-documents-list">
            {documents.map((document) => (
              <li key={document.year}>
                <div className="financial-document-info">
                  <strong>
                    {document.year} - {documentTitle}
                  </strong>
                  <span>Divulgadas em {document.publishedAt}</span>
                </div>

                <div className="financial-document-actions">
                  <a
                    href={document.pdfUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Visualizar
                  </a>
                  <a href={document.pdfUrl} download>
                    Baixar PDF
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FinancialStatements;
